import React from 'react';

const HorizontalLineBlock = () => <hr />;

HorizontalLineBlock.displayName = 'HorizontalLineBlock';

export default HorizontalLineBlock;
